import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Button, Modal as ReactstrapModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class SendEmailModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            subject: ''
        };
    }

    static propTypes = {
        isShowSendModal: PropTypes.bool,
        toggleSendModal: PropTypes.func.isRequired,
        onSend: PropTypes.func.isRequired,
        orderNum: PropTypes.string,
        deliveryDate: PropTypes.string,
        clientName: PropTypes.string,
    };

    static defaultProps = {
    };

    UNSAFE_componentWillReceiveProps(newProps) {
        this.setState({subject: `Labels for ${newProps.clientName} - Order # ${newProps.orderNum} for collection on ${newProps.deliveryDate}`, email:''});
    }

    handleEmailChange(e) {
        this.setState({email: e.target.value});
    }

    handleSubjectChange(e) {
        this.setState({subject: e.target.value});
    }

    handleSend(email, subject) {
        if (email === '') {
            alert('Please input the email.');
            return;
        }
        if (subject === '') {
            alert('Please input the subject.');
            return;
        }
        this.props.onSend(email, subject);
    }
    
    render() {
        const {email, subject} = this.state;
        const {isShowSendModal} = this.props;
        return (
            <ReactstrapModal isOpen={isShowSendModal} toggle={() => this.props.toggleSendModal()} className="status-note-modal">
                <ModalHeader toggle={() => this.props.toggleSendModal()}>Send via email</ModalHeader>
                <ModalBody>
                    <label>
                        <p>Receipt<span className='c-red'>*</span>:</p>
                        <input
                            className="form-control"
                            type="email"
                            name="email"
                            value={email}
                            onChange={(e) => this.handleEmailChange(e)}
                        />
                    </label>
                    <label>
                        <p>Subject<span className='c-red'>*</span>:</p>
                        <input
                            className="form-control"
                            type="text"
                            name="subject"
                            value={subject}
                            onChange={(e) => this.handleSubjectChange(e)}
                        />
                    </label>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => this.handleSend(email, subject)}>Send</Button>
                    <Button color="secondary" onClick={() => this.props.toggleSendModal()}>Cancel</Button>
                </ModalFooter>
            </ReactstrapModal>
        );
    }
}

export default SendEmailModal;



// WEBPACK FOOTER //
// ./src/components/CommonModals/SendEmailModal.js